module.exports = __webpack_public_path__ + "img/274C.ec1d6b0b.svg";